<template>
    <div class="detail">
        <div v-if="consignmentDetail.data.status" class="not-found">			
            {{ consignmentDetail.data.status }}, please try again.
        </div>
        <div v-else>
            <banner-notification :header="consignmentDetail.data.notificationHeader" :notification="consignmentDetail.data.notification"></banner-notification>
            <tracking-status v-if="consignmentScans" :trackingstatus="trackingDetail"></tracking-status>
            <tracking-summary :consignmentNote="consignmentDetailSummary.ConsignmentNote" :consigned="formatDate(consignmentDetailSummary.Released, 'YYYY-MM-DD')" :reference= "consignemntReferences" :sender="consignmentDetailSummary.SenderLocation" :receiver="consignmentDetailSummary.ReceiverLocation" :eta="formatDateETA(consignmentDetailSummary.ETA,'YYYY-MM-DD')"></tracking-summary>
            <tracking-carrier :carrierName="consignmentDetailSummary.CarrierName" :trackingPage="consignmentDetailSummary.CarrierTrackingPage" :consignmentNote="consignmentDetailSummary.ConsignmentNote"></tracking-carrier>
            <tracking-items :noItems="consignmentDetailSummary.Items.length" :weight="consignmentDetailSummary.Weight" :volume="consignmentDetailSummary.Volume"></tracking-items>
            <tracking-details :items="consignmentDetailSummary.Items" :scans="consignmentScans"></tracking-details>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        props: {
            consignmentDetail: Object
        },
        computed: {
            consignmentDetailSummary() {
                return this.consignmentDeserialized
            },
            consignemntReferences() {
                
                var conNote=this.consignmentDeserialized.ConsignmentNote;
                var refs = this.consignmentDeserialized.References;

                return refs.filter(reference => reference != conNote)
                            .join(', ');
            },
            consignmentScans() {
                return this.consignmentDeserialized.Scans
            },
            trackingDetail() {

                var s = this.consignmentDeserialized.Scans
                s = s.sort((a, b) => (a.Scanned > b.Scanned) ? -1 : 1)
                return s.length > 0 ? s[0].ScanType : ""
            },
            consignmentDeserialized() {
                return JSON.parse(this.consignmentDetail.data.consignmentDetail);
            }
        },
        methods: {
            formatDate(datetime, format) {
                return moment(String(datetime)).format(format)
            },

            formatDateETA(datetime, format) {
                if (!datetime) // If null
                    return "No ETA Available";

                return moment(String(datetime)).format(format)
            }
        }
    }
</script>
<style>
    .not-found {
        text-transform: lowercase;
        color: #D8000C;
        background-color: #FFD2D2;
        margin: 10px 0px;
        padding: 12px;
        margin: 10px 22px;
        font-size: 1em;
        vertical-align: middle;
    }

    .not-found::first-letter {
        text-transform: capitalize;
    }
</style>